import { useEffect } from 'react';
import { LikelyToFillIndicator } from '~/constants/ff.posthog';
import { usePosthog } from '~/hooks/usePosthog';
import { useShiftRequestFlowTracking } from '../../../ShiftRequestFlowTracking';

const EXPERIMENT_ARMS: readonly string[] = ['control', 'treatment'];

/** Skip offices outside the rollout (flag false or unset) so they don't dilute the test. */
export const useLikelyToFillExposure = (enabled: boolean): void => {
  const posthogService = usePosthog();
  const { recordLikelyToFillExposure } = useShiftRequestFlowTracking();

  useEffect(() => {
    if (!enabled || !posthogService) return undefined;

    // The PosthogService wrapper drops the SDK's unsubscribe, so ignore late callbacks after unmount.
    let active = true;
    let recorded = false;
    const record = () => {
      if (!active || recorded) return;
      const variant = posthogService.getFeatureFlagVariant(LikelyToFillIndicator);
      if (typeof variant !== 'string' || !EXPERIMENT_ARMS.includes(variant)) return;
      recorded = true;
      recordLikelyToFillExposure(variant);
    };

    if (posthogService.areFlagsReady()) record();
    // Also covers a later reload (e.g. after identify) that puts the office into an arm.
    posthogService.onFeatureFlags(record);

    return () => {
      active = false;
    };
  }, [enabled, posthogService, recordLikelyToFillExposure]);
};
